import { get, post } from './http'

export default {
  getAdvertInfoList(businessid) {
    return get('event/getAdvertInfoList', {
      businessid: businessid
    });
  },
  getScopeTypeList(businessid) {
    return get('scopegoods/getScopeTypeAll', {
      businessid: businessid
    });
  },
  getScopeGoodsList(infoid) {
    return get('ScopeGoods/getScopeInfoGoodsList', {
      infoid: infoid
    });
  },
  getScopeGoodsInfo(goodsid) {
    return get('ScopeGoods/getScopeGoodsInfo', {
      goodsid: goodsid
    });
  },
  // 机票:1/旅游:2/门票:3/产品:4
  getFlightShopList(infoid) {
    return get('scopegoods/getScopeInfoGoodsList', {
      infoid: infoid
    });
  },
}



// WEBPACK FOOTER //
// ./src/request/scopeApi.js